import { useMutation } from "@tanstack/react-query";
import { saveSevenRoomsMappings } from "../../api/bSevenroomsApi";

export const useSaveSevenRoomsMappings = () => {
  return useMutation({
    mutationKey: ["save-sevenrooms-mappings"],
    mutationFn: (data) => saveSevenRoomsMappings(data),
    onError: (error) => {
      console.error("SevenRooms mapping save error:", error.response || error);
    },
  });
};
